import { render, staticRenderFns } from "./ViewBooking.vue?vue&type=template&id=59bc8fa6"
import script from "./ViewBooking.vue?vue&type=script&lang=js"
export * from "./ViewBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports